import Vue from 'vue'
import api from '@appbase/api'
import { NavigationGuard } from 'vue-router'
import { setI18nLanguage } from '@appbase/util'
import store from '@/store'

const langCodes: string[] = ['ko', 'en', 'cn', 'uz', 'ru'];

const I18nGuard: NavigationGuard = async (to, from, next) => {
    var lang = Office.context.displayLanguage.substring(0, 2)
    const current = (store.state as any).$account?.current as account.TCurrent | null | undefined
    console.log(`Evaluating ${I18nGuard.name}: ${lang}`)

    if(current) {
        if (lang == 'zh') {
            lang = 'cn';
        }
    
        if (!(langCodes.indexOf(lang) >= 0)) {
            lang = 'en';
        }
            
        try {
            const dic = await api.cache.loadDictionary(lang, current.cacheVersion.lang || 0)
            Vue.prototype.portalCache = {
                ...Vue.prototype.portalCache,
                dic,
                lang,
            }
            setI18nLanguage(lang, dic)
            next()
        } catch (err) {
            // 에러 발생시 ErrorView로 이동(appbase의 ErrorView 사용)
            console.error(`Failed to load dictionary for ${lang}`, err);
            const errorData = encodeURIComponent(JSON.stringify({
                title: 'error',
                message: 'Failed to load dictionary'
            }));
            next({ name: 'error', query: { data: errorData } })
        }
    } else {
        // throw 대신 next()로 에러 페이지 연결(appbase의 ErrorView 사용)
        const errorData = encodeURIComponent(JSON.stringify({
            title: 'error',
            message: 'Account is not initialized'
        }));
        next({ name: 'error', query: { data: errorData } })
        
    }    
}

export default I18nGuard
